import { render, staticRenderFns } from "./ftp-info-index.vue?vue&type=template&id=588191eb&scoped=true&"
import script from "./ftp-info-index.vue?vue&type=script&lang=js&"
export * from "./ftp-info-index.vue?vue&type=script&lang=js&"
import style0 from "./ftp-info-index.vue?vue&type=style&index=0&id=588191eb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588191eb",
  null
  
)

export default component.exports